import { ChargingStationDto } from '../chargingStationDto';
import { ChargingStationModel } from '../chargingStationModel';
import { evsesRule } from '../evsesRule';

export function chargingStationsNormalizer(
  chargingStationDtos: ChargingStationDto[]
): ChargingStationModel[] {
  return chargingStationDtos.map((chargingStationDto) => {
    return {
      id: chargingStationDto.chargingStationId.toString(),
      identityKey: chargingStationDto.identityKey ?? 'N/A',
      model: chargingStationDto.chargingStationModel ?? 'N/A',
      name: chargingStationDto.chargingStationName ?? 'N/A',
      evses: evsesRule(chargingStationDto.evses),
      status:
        chargingStationDto.ocppStatus === null
          ? 'PROVISIONED'
          : chargingStationDto.ocppStatus,
      location: locationNormalizer(chargingStationDto.locationDetails),
    };
  });
}

const locationNormalizer = (locationDetails: {
  name: string;
  id: string;
}): ChargingStationModel['location'] => {
  if (!locationDetails) {
    return {
      id: '',
      name: 'Unassigned',
    };
  }
  return {
    id: locationDetails.id ?? '',
    name: locationDetails.name ?? 'N/A',
  };
};
